import { insertBody } from "../DomUtilities/ElementsUtil";
import openErrorModal from "../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";
import { createStore, fetchCreateStoreModal } from "../HTTPRequests/StoreRequests";
import Store from "../Models/Store";
import Mediator from "../Utilities/Mediator";
import EConomicForm from "./EConomicForm";
import StoreBaseModal from "./StoreBaseModal";

export default class CreateStoreModal extends StoreBaseModal {
	modalDiv: HTMLDivElement;
	createButton: HTMLButtonElement;
	economicHandler: EConomicForm;

	constructor(createStoreButton: HTMLButtonElement) {
		super();
		this.modalDiv = document.createElement('div');
		this.createButton = createStoreButton;
		this.economicHandler = new EConomicForm();
	}

	public addCreateModalClickListener() {
		this.createButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchCreateStoreModal();
		}
	}

	private fetchCreateStoreModal() {
		fetchCreateStoreModal()
			.then((response: string) => {
				this.openCreateModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openCreateModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);
		this.selectFormFields();
		this.addCVRValidator();
		this.addEConomicCheckBoxChangeListener();

		const cancelButton: HTMLButtonElement = this.modalDiv.querySelector('button');
		cancelButton.onclick = () => {
			this.modalDiv.remove();
		};

		const img: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		img.onclick = () => {
			this.modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = this.modalDiv.querySelector('button:last-child');
		saveButton.onclick = () => {
			this.saveCreatedStore();
		}
	}

	private addEConomicCheckBoxChangeListener() {
		const economicCheckBox: HTMLInputElement = this.modalDiv.querySelector("#economic");
		const modalBody: HTMLDivElement = this.modalDiv.querySelector("div.modal__body");
		const formsWrapper: HTMLDivElement = this.modalDiv.querySelector(".modal__body > div");
		const wrapper = document.createElement('div');

		insertBody(formsWrapper, wrapper);
		this.economicHandler.init(modalBody, wrapper);

		economicCheckBox.onchange = () => {
			this.economicHandler.toggleForm(economicCheckBox.checked);
		}
	}

	private saveCreatedStore() {
		let { valid, store } = this.modalData;
		if (valid) {
			document.body.append(this.loadingScreen);
			this.createStore(store);
		} else {
			this.form.reportValidity();
		}
	}

	private createStore(store: Store) {
		createStore(store)
			.then((response: number) => {
				this.openResultMessageModal(response);
				this.modalDiv.remove();
				Mediator.emit("storeCrudOperationFinished");
				this.economicHandler.destroy();
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openResultMessageModal(response: number) {
		const modal: HTMLDivElement = document.querySelector("#create-store-modal");
		const successMsg: string = modal.dataset.success;
		const errorMsg: string = modal.dataset.error;
		if (response < 400) {
			openErrorModal(successMsg, "#AAC291", "  ");
			this.loadingScreen.remove();
		} else {
			openErrorModal(errorMsg);
			this.loadingScreen.remove();
		}
	}
}
